import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export async function getStoreItem(uId, storeId) {
  const token = await authToken(uId);

  var config = {
    method: 'post',
    url: cfac22('API_HOST_V2') + '/stores/getStoreItem',
    headers: {
      Authorization: 'Bearer ' + token,
      'Full-Url': window.location.href,
    },
    data: { storeId },
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(function (response) {
        resolve(response.data.response);
      })
      .catch(function (error) {
        reject(error.response.data);
      });
  });
}
